import { render, staticRenderFns } from "./AddDetail.vue?vue&type=template&id=8ed6c1e2&scoped=true&"
import script from "./AddDetail.vue?vue&type=script&lang=js&"
export * from "./AddDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddDetail.vue?vue&type=style&index=0&id=8ed6c1e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed6c1e2",
  null
  
)

export default component.exports